<template>
  <v-dialog
    v-model="computedElectricalSubstationsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('electrical', 'substations')">
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title class="hidden-sm-and-down"
          >25 kV High Voltage</v-toolbar-title
        >
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <!-- padding to fix vuetify bug that should be fixed in 1.10 -->
        <v-select
          :items="select_mountain_items"
          v-model="select_mountain_model"
          style="padding-top:23px;"
        ></v-select>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :headers="headers"
          :items="computedElectricalSubstationsGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedElectricalSubstationsLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                siteView = true;
                siteViewSite = props.item.site;
              "
            >
              <td>{{ props.item.site }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>

    <!-- site view dialog -->
    <v-dialog
      v-model="siteView"
      hide-overlay
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="siteView = false">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ siteViewSite }}</v-toolbar-title>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
        </v-toolbar>
        <div
          style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
        >
          <v-data-table
            :headers="siteViewHeaders"
            :items="computedElectricalSubstationsSiteFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'electrical',
                    'substations',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.sub_name }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
"dataElectricalSubstations";
export default {
  data() {
    return {
      siteView: false,
      siteViewSite: "",
      siteViewHeaders: [
        {
          text: "Site",
          value: "site"
        }
      ],
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      loading: true,
      search: "",
      rows_per_page: [10, 25, 50, { text: "All", value: -1 }],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Site",
          value: "site"
        }
      ]
    };
  },
  computed: {
    computedElectricalSubstationsSiteFeatures() {
      if (
        this.$store.state.mapLayers.electrical.layers.substations.geojson
          .features
      ) {
        const site = this.$store.state.mapLayers.electrical.layers.substations
          .geojson.features;
        const siteContents = site.filter(
          item => item.properties.site == this.siteViewSite
        );
        return siteContents;
      }
      return [];
    },
    computedElectricalSubstationsGeoJsonFeatures() {
      // chainable function to return only unique values of an array
      Array.prototype.unique = function() {
        return this.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };
      if (
        this.$store.state.mapLayers.electrical.layers.substations.geojson
          .features
      ) {
        const subs = this.$store.state.mapLayers.electrical.layers.substations
          .geojson.features;
        if (this.select_mountain_model == "Whistler") {
          const subsWhis = subs.filter(
            item => item.properties.mountain == "Whistler"
          );

          let a = []; // blank array
          for (let i = 0; i < subsWhis.length; i++) {
            a.push(subsWhis[i].properties.site); // push all sites into array a
          }

          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              site: b[i]
            });
          }

          return results; // returns json with only unique sites
        } else if (this.select_mountain_model == "Blackcomb") {
          const subs = this.$store.state.mapLayers.electrical.layers.substations
            .geojson.features;
          const subsBlk = subs.filter(
            item => item.properties.mountain == "Blackcomb"
          );

          let a = []; // blank array
          for (let i = 0; i < subsBlk.length; i++) {
            a.push(subsBlk[i].properties.site); // push all sites into array a
          }
          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              site: b[i]
            });
          }

          return results; // returns json with only unique sites
        } else if (this.select_mountain_model == "Both Mountains") {
          const subsBoth = this.$store.state.mapLayers.electrical.layers
            .substations.geojson.features;

          let a = []; // blank array
          for (let i = 0; i < subsBoth.length; i++) {
            a.push(subsBoth[i].properties.site); // push all sites into array a
          }

          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              site: b[i]
            });
          }

          return results; // returns json with only unique sites
        }
      }
      return [];
    },
    computedElectricalSubstationsVisibility() {
      return this.$store.state.mapLayers.electrical.layers.substations
        .visibility.listView;
    },
    computedElectricalSubstationsLoading() {
      return this.$store.state.mapLayers.electrical.layers.substations.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    unique() {
      Array.prototype.unique = function() {
        return this.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      if (utcdate !== null) {
        return y + "-" + m + "-" + d;
      } else {
        return;
      }
    },
    // method to get geojson
    methodGetElectricalSubstationsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/electrical/substations",
        dept: "electrical",
        layer: "substations",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.electrical.layers.substations.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetElectricalSubstationsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.electrical.layers.substations.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
